import * as React from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";

export default function FullPageLoader() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        position: "relative",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <CircularProgress color="secondary" />
    </Box>
  );
}
